<template>
<el-container>
  <el-aside :width="asidewidth">
    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo mainMenu"
      :collapse="isCollapse"
      :collapse-transition="false"
      router
      unique-opened
      background-color="#fff"
      text-color="#000"
      active-text-color="#409EFF">
        <el-menu-item style="text-align:center;color:#000">
          <router-link to='/home/index'>
            <!-- <img style="width: 80%;" src="../assets/logo.png"> -->
          </router-link>
        </el-menu-item>
        <menu-tree v-for="(item,index) in menuTree" :key="index" :menu="item"></menu-tree>
    </el-menu>
  </el-aside>
  <el-container>
    <el-header>
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        background-color="#fff"
        text-color="#000"
        active-text-color="#409EFF">
        <el-menu-item index="1" @click="showMenu">
          <i :class="showMenuIcon"></i>
        </el-menu-item>
        <el-menu-item v-for="(val, key) in submenu" @click="changeUrl(val.url)" :key="key" :index="val.url">
          {{val.name}}
        </el-menu-item>
        <div style="float:right">
          <el-menu-item @click="loginout()">
            退出
          </el-menu-item>
        </div>
        <div style="float:right">
          <el-menu-item>
            {{mname}}
          </el-menu-item>
        </div>
      </el-menu>
    </el-header>
    <el-main style="background: rgb(250, 250, 250);">
      <router-view/>
    </el-main>
  </el-container>
</el-container>
</template>
<script>
import commonFunction from "@/api/common"
import MenuTree from '@/components/common/MenuTree' //动态菜单
export default {
  components: {
    MenuTree,
  },
  created() {
  },
  data() {
    return {
      mname:sessionStorage.getItem('name'),
      submenu:[],
      isCollapse:false,
      token:sessionStorage.getItem('token'),
      menuTree:[],
      asidewidth:'160px',
      showMenuIcon:'el-icon-s-fold',
    }
  },
  methods:{
    showMenu(){
      var isCollapse = this.isCollapse;
      if(isCollapse){
        this.isCollapse = false;
        this.asidewidth = '160px';
        this.showMenuIcon = 'el-icon-s-fold';
      }else{
        this.isCollapse = true;
        this.asidewidth = '64px';
        this.showMenuIcon = 'el-icon-s-unfold';
      }
    },
    getMenu(params){
      commonFunction.getMenu(params,this).then(res=>{
        this.menuTree = res
      }).catch(err=>{
        this.$message.error(err);
      })
    },
    loginout(){
      sessionStorage.setItem('token','')
      this.$router.push('/')
    },
    changeUrl(url){
      this.$router.push(url)
    }
  },
  mounted () {
    this.getMenu({vcode:this.token})
  }
}
</script>
<style>
.el-header{
  padding: 0;
}
.mainMenu{
  height:100%;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue